import { render, staticRenderFns } from "./save_practice_plan.vue?vue&type=template&id=25d0ad29&"
import script from "./save_practice_plan.vue?vue&type=script&lang=js&"
export * from "./save_practice_plan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports